import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/shared/global-constants';
import { Widget } from 'src/app/shared/models/widget.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss']
})
export class PortalComponent implements OnInit {
  widgets: object = [];
  objectKeys = Object.keys;
  loading: boolean = false;

  RoleName: string;
  Moderator = GlobalConstants.Moderator;
  Publisher = GlobalConstants.Publisher;
  dloUser = GlobalConstants.dloUser;
  Drafted = GlobalConstants.Drafted;
  Published = GlobalConstants.Published;
  PendingApproval = GlobalConstants.PendingApproval;
  Deleted = GlobalConstants.Deleted;
  Rejected = GlobalConstants.Rejected;
  widgetIconMap = new Map<string, string>([
    ["Drafted", "#dds__pencil"],
    ["Pending Approval", "#dds__task-check-progress"],
    ["Published", "#dds__task-check"],
    ["Rejected", "#dds__cancelled"],
    ["Deleted", "#dds__trash"],
  ]);

  constructor(private authService: AuthService, private commonService: CommonService, private router: Router) { }

  ngOnInit(): void {
    this.authService.itemValue.subscribe((nextValue) => {
      this.RoleName = nextValue.RoleName;
    });

    this.commonService.getWidgets();
    this.loading = true;
    this.commonService.getWidgetUpdateListener().
      subscribe(
        (widgetsData: Widget[]) => {
          this.widgets = widgetsData;
          if (this.RoleName === this.Publisher)
            delete this.widgets[this.Deleted]
          this.loading = false;

        },
        (error => { console.log(error) })
      )
  }
}
